export default __webpack_public_path__ + "static/media/i16.65fd0239.jpeg";